import { BootController } from '../../boot-control';
import { Injectable, NgZone, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoginService } from '../services/login.service';
import { TokenStorageService } from '../services/token-storage.service';
import { NotifierService } from 'angular-notifier';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	@BlockUI() blockUI: NgBlockUI;
	private readonly notifier: NotifierService;
	constructor(
		private injector: Injector,
		private notifierService: NotifierService,
		private router: Router,
		private ngZone: NgZone,
		private token: TokenStorageService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next.handle(request).pipe(catchError(err => {
			// console.log('err : ', err, request);

			if (err.status === 401) {

				if (request.url.endsWith('/user/validate') || request.url.endsWith('/forgetPassword') || request.url.endsWith('/resetPassword') || request.url.endsWith('/user/signon')) {
					localStorage.removeItem('AuthorizationD');
					localStorage.removeItem('JSESSIONID');
					localStorage.removeItem('token');
					localStorage.removeItem('expires_at');
					localStorage.removeItem('selectedTile');
					localStorage.removeItem('widgets');
					localStorage.removeItem('loggedInUser');
					localStorage.removeItem('userId');
					localStorage.removeItem('orgConfig');

					if(err.error.message) {
						return throwError(err.error.message);
					} else {
						return throwError('Unauthorized access');
					}
				} else {
					const loginService = this.injector.get(LoginService);
					loginService.logout().then(data => {
						localStorage.removeItem('AuthorizationD');
						localStorage.removeItem('JSESSIONID');
						localStorage.removeItem('token');
						localStorage.removeItem('expires_at');
						localStorage.removeItem('selectedTile');
						localStorage.removeItem('widgets');
						localStorage.removeItem('loggedInUser');
						localStorage.removeItem('userId');
						this.token.signOut();

						// Triggers the reboot in main.ts
						this.ngZone.runOutsideAngular(() => BootController.getbootControl().restart());

						this.router.navigate(['/login']);

						return throwError('Unauthorized access');
					  },
					  error => {

					  });
				}
				return throwError('Unauthorized access');

				// location.reload(true);
			} else if (err.status == 504 || err.status == 400 || err.status == 404 || err.status == 500) {
				return throwError(err);
			}

			// console.log(err);

			let error
			if (err.error) {
				error = err.error.message;
			} else {
				error = null
			}

			if (error) {
				this.blockUI.stop();
				return throwError(error);
			} else {
				this.blockUI.stop();
				// console.log(error)
				//this.notifier.notify('error', 'Server is temporary down.Please try again after sometime!');
				return throwError('Server is temporary down. Please try again after sometime!');
			}

		}))
	}
}
